import { useQuery } from '@hooks/reactQuery';

import { getConnectionLogs } from '@api/middlewareSMO';

import { extractQueryParams } from '@utils/common';

import { TPartialPick } from '@interfaces/common/genericWithModifying';
import { IConnectionLog } from '@interfaces/middlewareSMO/connectionLogs';
import { IConnectionLogsDTO } from '@interfaces/middlewareSMO/dto/connectionLogsDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { MIDDLEWARE_SMO_CONNECTION_LOGS } from '@constants/queryKeys';
import { CONNECTION_LOGS_FIELD_NAMES } from '@components/routes/AdminPanel/ManageMiddlewareSMO/constants';

interface IUseQueryConnectionLogsReturned {
	connectionLogsData: IConnectionLog[];
	countOfRecords: number;
	isLoadingConnectionLogs: boolean;
}

const useQueryConnectionLogs = (
	params: TPartialPick<
		IConnectionLogsDTO,
		typeof CONNECTION_LOGS_FIELD_NAMES.connectionStatus |
		typeof CONNECTION_LOGS_FIELD_NAMES.eventType |
		typeof CONNECTION_LOGS_FIELD_NAMES.source |
		typeof CONNECTION_LOGS_FIELD_NAMES.userId |
		typeof CONNECTION_LOGS_FIELD_NAMES.middlewareId
	>,
): IUseQueryConnectionLogsReturned => {
	const {
		page,
		pageSize,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [MIDDLEWARE_SMO_CONNECTION_LOGS, params],
		queryFn: extractQueryParams(getConnectionLogs),
		enabled: [!!page, !!pageSize],
		allowedRoles: [EUserRoles.smoLightViewer, EUserRoles.smoLightUpdater],
		...refetchOptions,
	});

	return {
		connectionLogsData: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConnectionLogs: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryConnectionLogs;
